<section>
  <div class="mb-3 d-flex align-items-center justify-content-between">
    <h4 class="text-white position-relative">
      <strong
        >Bulk UUID
        <small
          >({{ bulk_irn_data.length ? bulk_irn_data.length : 0 }})</small
        ></strong
      >
    </h4>
    <div class="mx-2">
      <div class="form-group calendar w-c-50 position-relative">
        <input
          class="form-control h-auto"
          [(ngModel)]="filters.search.creation"
          (dateTimeChange)="updateRouterParams()"
          [owlDateTime]="dt1"
          [selectMode]="'range'"
          [owlDateTimeTrigger]="dt1"
          placeholder="Date"
          [max]="today"
        />
        <span
          *ngIf="!filters.search.creation"
          class="example-trigger"
          [owlDateTimeTrigger]="dt1"
        >
          <i class="ri-calendar-2-line ml-2"></i>
        </span>
        <i
          *ngIf="filters.search.creation"
          class="ri-close-line"
          (click)="clearcreationdate()"
        ></i>
        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
      </div>
    </div>
  </div>

  <!-- ======================== BULK IRN DATA TABLE ======================== -->

  <div class="card">
    <div class="card-body p-0 pb-3">
      <div class="table-responsive">
        <table class="table">
          <thead #head>
            <tr>
              <th>#</th>
              <th>Id</th>
              <th>Total Count</th>
              <th>Pending Count</th>
              <th>Success Count</th>
              <th>Creation Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of bulk_irn_data; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item?.name }}</td>
              <td>
                {{ item?.total_count }}
              </td>
              <td>{{ item?.pending_count }}</td>
              <td>{{ item?.success_count }}</td>
              <td>{{ item?.creation | date : "dd/MM/yyyy , hh:mm:ss" }}</td>
              <td (click)="showpendingcount(item)" class="cursor">
                <i class="ri-eye-line p-1"></i>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="text-center py-3" *ngIf="!bulk_irn_data?.length">
          <h5>No Data Found</h5>
        </div>
      </div>
      <div class="d-flex justify-content-between" *ngIf="bulk_irn_data?.length">
        <div class="px-3">
          <select
            class="custom-select"
            name="itemsPerPage"
            [(ngModel)]="filters.itemsPerPage"
            (change)="checkPagination()"
            id="itemsPerPage"
          >
            <option [value]="20">20</option>
            <option [value]="50">50</option>
            <option [value]="100">100</option>
            <option [value]="150">150</option>
            <option [value]="500">500</option>
            <option [value]="2500">2500</option>
          </select>
        </div>
        <div *ngIf="bulk_irn_data.length < this.filters.totalCount">
          <p
            class="text-right pr-5 more text-primary"
            (click)="
              this.filters.start = bulk_irn_data.length;
              this.filters.currentPage =
                convertToNumber(this.filters.currentPage) + 1;
              updateRouterParams()
            "
          >
            more
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============================= PENDING BULK IRN MODAL ============================= -->

<ng-template #pendingbulkirn let-modal>
  <div class="modal-header">
    <h5 class="" id="modal-basic-title">
      Bulk UUID
      <small
        >({{
          (bulkirntotaldata | statusfilter : filters.search.status)?.length
        }})</small
      >
    </h5>

    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="card">
      <div class="card-body p-0 pb-3">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Invoice Number</th>
                <th>Status</th>
                <th>Error Message</th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngIf="
                  bulkirntotaldata
                    | statusfilter : filters.search.status as filteredData
                "
              >
                <tr>
                  <td></td>
                  <td>
                    <!-- (ngModelChange)="updateRouterParams()" -->
                    <select
                      name="irn_status"
                      id="irn_status"
                      class="custom-select"
                      [(ngModel)]="filters.search.status"
                    >
                      <option value="All">All</option>
                      <option value="Pending">Pending</option>
                      <option value="Success">Success</option>
                    </select>
                  </td>
                  <td></td>
                </tr>
                <tr
                  *ngFor="
                    let key of bulkirntotaldata
                      | statusfilter : filters.search.status
                  "
                >
                  <td>
                    <a
                      [routerLink]="['/home/invoice-details/' + key?.invoice]"
                      [queryParams]="{ prop: 'invoice' }"
                      class="view"
                      aria-label="Close"
                      (click)="modal.dismiss('Cross click')"
                    >
                      {{ key?.invoice }}</a
                    >
                  </td>
                  <td>
                    {{ key?.status }}
                  </td>
                  <td
                    style="max-width: 200px"
                    placement="top"
                    ngbTooltip="{{ key?.error }}"
                  >
                    {{ key?.error }}
                  </td>
                </tr>
                <tr *ngIf="!filteredData.length">
                  <td colspan="3" class="text-center">
                    <h5>No Data Found</h5>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="close-icon">
    <i (click)="modal.dismiss(); bulkirnclose()" class="ri-close-line"></i>
  </div>
</ng-template>
